import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import { router } from './Routes/Routes';
import "./i18n";
import './App.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AuthProvider } from './utils/AuthContext';
import { startNicuSync } from './services/nicuSyncEngine';

// Register the service worker
serviceWorkerRegistration.register();
startNicuSync();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={null} >
    <React.StrictMode>
    <AuthProvider>
  
    <RouterProvider router={router} />
        
    </AuthProvider>
    </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
